<template>
  <div class="adminiStration_zk">
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <div class="content">
        <el-row>
          <el-col :span="4" :offset="0">
            <el-card class="box-card" style="height: 87vh">
              <el-tabs
                style="height: 95%"
                v-model="activeName"
                @tab-click="handleClick"
              >
                <el-tab-pane label="显示全部成员" name="first">
                  <!-- 树形控件地方 -->
                  <Components-tree
                    ref="tree"
                    :showRightClick="true"
                    :isAllchecked="true"
                    :enable="true"
                    @updateIds="clickTreeIds"
                    @addTree="addTree"
                    @editTree="editTree"
                    @upDrop="upDrop"
                    @delTree="delTree"
                    :treeData="zNodes"
                    :item="item"
                  ></Components-tree>
                </el-tab-pane>
              </el-tabs>
            </el-card>
          </el-col>
          <el-col :span="20" :offset="0" style="padding-left: 25px">
            <el-row>
              <el-col :span="12" :offset="0">
                <div class="topbtn" style="margin-left: -20px">
                  <el-button
                    type="text"
                    @click="dialogVisibleInviteEmployees = true"
                  >
                    <img
                      src="../../../assets/img/company/companyInvite.png"
                      style="width: 16px; height: 16px; margin-bottom: 6px"
                    /><span style="font-size: 15px; color: #035dff">
                      邀请员工</span
                    ></el-button
                  >
                  <el-button
                    type="text"
                    @click="dialogVisibleAddEmployees = true"
                  >
                    <img
                      src="../../../assets/img/company/companyAddstaff.png"
                      style="width: 16px; height: 16px; margin-bottom: 6px"
                    /><span style="font-size: 15px; color: #035dff">
                      添加员工</span
                    ></el-button
                  >
                  <el-button type="text" @click="exportExcel">
                    <img
                      src="../../../assets/img/company/companyexport.png"
                      style="width: 16px; height: 16px; margin-bottom: 6px"
                    /><span style="font-size: 15px; color: #035dff">
                      导出员工</span
                    ></el-button
                  >
                  <el-button
                    type="text"
                    @click="dialogVisibleExEmployees = true"
                  >
                    <img
                      src="../../../assets/img/company/companyimport.png"
                      style="width: 16px; height: 16px; margin-bottom: 6px"
                    /><span style="font-size: 15px; color: #035dff">
                      导入员工</span
                    ></el-button
                  >
                  <el-button type="text" @click="dialogVisibleEmpNum = true">
                    <img
                      src="../../../assets/img/company/companyinviteNum.png"
                      style="width: 18px; height: 18px; margin-bottom: 6px"
                    /><span style="font-size: 15px; color: #035dff">
                      企业邀请码</span
                    ></el-button
                  >
                </div>
              </el-col>
              <el-col :span="5" :offset="0"> &nbsp;</el-col>
              <el-col :span="6" :offset="0" style="padding-top: 15px">
                <div class="inputzuhekuang" style="">
                  <el-input
                    v-model="search"
                    class="input-with-select"
                    style="width: 300px"
                  >
                    <el-button
                      slot="append"
                      @click="GetCompanyUserList()"
                      icon="el-icon-search"
                    ></el-button>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="1" :offset="0" style="padding-top: 15px">
                <el-button type="text" @click="rotate()">
                  <img
                    :class="{ go: addRotate }"
                    src="../../../assets/img/company/revser.png"
                    style="width: 16px; height: 16px; margin-bottom: 6px"
                  /><span style="font-size: 15px; color: #035dff">
                    重置</span
                  ></el-button
                >
              </el-col>
            </el-row>
            <hr />
            <div>
              <el-table
                :data="tableData"
                v-loading="tableLoading"
                element-loading-text="成员加载中..."
                style="width: 100%"
                max-height="690px"
                class="table"
              >
                <el-table-column type="index" label="序号"> </el-table-column>
                <el-table-column prop="user16" label="账号"> </el-table-column>
                <el-table-column prop="user02" label="姓名"> </el-table-column>
                <el-table-column prop="user03" label="性别"> </el-table-column>
                <el-table-column prop="user05" label="电话"> </el-table-column>
                <el-table-column prop="user04" label="邮箱"> </el-table-column>
                <el-table-column prop="user17" label="年龄"> </el-table-column>
                <el-table-column prop="DeptName" label="部门">
                  <template slot-scope="scope">
                    {{
                      scope.row.userCompanyState == "待审核"
                        ? ""
                        : scope.row.DeptName
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="ShareNum" label="分享构件数量">
                </el-table-column>
                <el-table-column prop="user11" label="注册时间">
                </el-table-column>
                <el-table-column prop="userCompanyState" label="状态">
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      @click="HandleUserInComoany(scope.row, 1)"
                      v-if="scope.row.userCompanyState == '待审核'"
                      type="text"
                      >同意</el-button
                    >
                    <el-button
                      @click="HandleUserInComoany(scope.row, 2)"
                      v-if="scope.row.userCompanyState == '待审核'"
                      type="text"
                      style="color: red"
                      >拒绝</el-button
                    >
                    <el-button
                      @click="HandleUserInComoany(scope.row, 3)"
                      v-if="
                        scope.row.userCompanyState == '已邀请' ||
                        scope.row.userCompanyState == '被拒绝'
                      "
                      type="text"
                      >重新邀请</el-button
                    ><el-button
                      v-if="scope.row.userCompanyState == '被拒绝'"
                      type="text"
                      @click="DelCompanyUserMsg(scope.row)"
                      >移除</el-button
                    >
                    <div v-if="scope.row.userCompanyState == '正常'">
                      <el-button type="text" @click="del(scope.row)"
                        >移除</el-button
                      >
                      <el-button type="text" @click="edit(scope.row)"
                        >修改</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                class="ppfixed"
                style="left: 50%"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                align="center"
                background
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <!-- 邀请员工 -->
    <el-dialog
      :append-to-body="true"
      title="邀请员工"
      :visible.sync="dialogVisibleInviteEmployees"
      width="30%"
    >
      <el-form ref="form" label-width="110px">
        <el-form-item label="账号/手机号：">
          <el-input v-model="InviteEmployeesOphoneNum"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="Invitesubmit()">确 定</el-button>
        <el-button @click="dialogVisibleInviteEmployees = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加员工 -->
    <el-dialog
      :append-to-body="true"
      title="添加员工"
      :visible.sync="dialogVisibleAddEmployees"
      width="50%"
    >
      <el-button
        style="margin-left: 30px"
        type="text"
        @click="btnuser('AddUserform')"
      >
        <img
          src="../../../assets/img/company/useradd.png"
          style="width: 18px; height: 18px; margin-bottom: 5px"
        /><span style="font-size: 15px; color: #035dff"> 添加</span></el-button
      >
      <el-form
        ref="AddUserform"
        v-for="(item, index) in AddClanfrom"
        :key="index"
        :model="item"
        :inline="true"
        label-width="30px"
        :rules="rules"
      >
        <el-form-item label=" " prop="account">
          <el-input v-model="item.account" placeholder="账号"></el-input>
        </el-form-item>
        <el-form-item label="" prop="name">
          <el-input v-model="item.name" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="" prop="pwd">
          <el-input
            v-model="item.pwd"
            style="width: 202px"
            type="password"
            show-password
            placeholder="密码"
            autocomplete="new-password"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="sex">
          <el-select v-model="item.sex" style="width: 202px" placeholder="性别">
            <el-option label="男" value="男"> </el-option>
            <el-option label="女" value="女"> </el-option>
          </el-select>
        </el-form-item>
        <el-button
          type="text"
          @click="Delconceal(item, index)"
          style="margin-left: 10px"
        >
          <img
            src="../../../assets/img/company/uesrdel.png"
            style="width: 16px; height: 16px; margin-bottom: 5px"
        /></el-button>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="Addsubmit('AddUserform')"
          >确 定</el-button
        >
        <el-button @click="dialogVisibleAddEmployees = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 导入员工 -->
    <el-dialog
      :append-to-body="true"
      title="导入员工"
      :visible.sync="dialogVisibleExEmployees"
      width="23%"
    >
      <p style="text-indent: 2em; padding: 0px 15px 10px 15px">
        点击下载模板表格：导入人员
        <!-- <span
          @click="ExportPersonTemplate"
          style="color: #035dff; cursor: pointer"
          >示例表格.xls</span
        > -->
        <a
          href="./fileTemplate/model_2.xlsx"
          style="color: #035dff; cursor: pointer"
          download="导入员工模板.xlsx"
          >模板下载</a
        >
        并按要求填写好后上传
      </p>
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="actionUrl"
        :on-change="handleChange"
        :file-list="fileList"
        :limit="1"
        :data="uploadData"
        :before-upload="beforeUpload"
        accept=".xlsx"
        :auto-upload="false"
        :on-success="uploadSuccess"
        :headers="importHeaders"
        :on-exceed="handleExceed"
      >
        <el-button style="color: #035dff; padding-left: 15px" type="text"
          >选择文件</el-button
        >
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpload()">确 定</el-button>
        <el-button @click="dialogVisibleExEmployees = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 企业邀请码 -->
    <el-dialog
      :append-to-body="true"
      title="企业邀请码"
      :visible.sync="dialogVisibleEmpNum"
      width="23%"
    >
      <el-row>
        <el-col :span="16" :offset="0">
          <h2 style="font-weight: 700; text-align: right">
            {{ EmpNum }}
          </h2>
        </el-col>
        <el-col :span="1" :offset="0">&nbsp;</el-col>
        <el-col :span="7" :offset="0"
          ><el-button
            type="text"
            id="btn_Share"
            @click="copy()"
            style="color: #035dff; margin-top: -8px"
            >复制</el-button
          ></el-col
        >
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleEmpNum = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 修改用户信息 -->
    <el-dialog
      :append-to-body="true"
      title="修改用户信息"
      :visible.sync="dialogVisibleEditInfo"
      width="35%"
    >
      <el-form
        ref="EditClanfromform"
        :rules="EditClanfromrules"
        :model="EditClanfrom"
        label-width="120px"
      >
        <el-form-item label="账号：">
          <el-input disabled v-model="EditClanfrom.user16"></el-input>
        </el-form-item>
        <el-form-item label="姓名：">
          <el-input v-model="EditClanfrom.user02"></el-input>
        </el-form-item>
        <el-form-item label="性别：" prop="user03">
          <el-select v-model="EditClanfrom.user03" placeholder="请选择">
            <el-option label="男" value="男"> </el-option>
            <el-option label="女" value="女"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电话：">
          <el-input v-model="EditClanfrom.user05"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：">
          <el-input v-model="EditClanfrom.user04"></el-input>
        </el-form-item>
        <el-form-item label="密码：">
          <el-input
            type="password"
            show-password
            v-model="EditClanfrom.user06"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门：">
          <el-select
            filterable
            v-model="EditClanfrom.user09"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in deps"
              :key="index"
              :label="item.dept02"
              :value="item.dept01"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年龄：" class="jifen">
          <el-input
            type="number"
            style="width: 40%"
            v-model="EditClanfrom.user17"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateSave('EditClanfromform')"
          >修 改</el-button
        >
        <el-button @click="dialogVisibleEditInfo = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
import {
  GetDeptZTree,
  AddDepttree,
  EditDepttree,
  DelDepttree,
  ChangeDepttreeOrder,
  GetCompanyUserList,
  InvitUser,
  CompanyAddUser,
  DelCompanyUser,
  UpdateUser,
  GetInvitationCode,
  HandleUserInComoany,
  ExportPersonTemplate,
  DelCompanyUserMsg,
} from "@/setAxios";
import ComponentsTree from "@/components/componentsTree";
export default {
  name: "adminiStration_zk",
  components: { ComponentsTree },
  data() {
    return {
      actionUrl: this.$store.state.baseUrl + "/api/ImportUserExcel",
      uploadData: {
        companyId: this.$store.state.pid,
      },
      importHeaders: { token: localStorage.getItem("token") },
      activeName: "first",
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      search: "",
      dialogVisibleInviteEmployees: false,
      InviteEmployeesOphoneNum: "",
      dialogVisibleAddEmployees: false,
      AddClanfrom: [{}],
      rules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
      },

      dialogVisibleExEmployees: false,
      fileList: [],
      dialogVisibleEmpNum: false,
      EmpNum: "",
      dialogVisibleEditInfo: false,
      EditClanfrom: {},
      EditClanfromphone: "",
      EditClanfromrules: {
        user02: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        user06: [{ required: true, message: "请输入密码", trigger: "blur" }],
        user03: [{ required: true, message: "请选择性别", trigger: "blur" }],
      },
      deps: [],
      zNodes: [],
      item: { name: "dept02", parentName: "dept05", id: "dept01" },
      ids: "",
      addRotate: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    DelCompanyUserMsg(row) {
      DelCompanyUserMsg({ uid: row.user01, companyid: localStorage.uid }).then(
        (res) => {
          if (res.Code) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.GetCompanyUserList();
          }
        }
      );
    },
    handleClick() {
      this.ids = "All";
      this.GetCompanyUserList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetCompanyUserList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetCompanyUserList();
    },
    btnuser(fromref) {
      this.AddClanfrom.push({});
    },
    Delconceal(val, index) {
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.AddClanfrom.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 添加员工
    Addsubmit(fromref) {
      let _this = this;
      this.AddClanfrom.forEach((element, index) => {
        this.$refs[fromref][index].validate(async (v) => {
          if (v) {
            let params = {
              companyid: localStorage.uid,
              account: element.account,
              name: element.name,
              sex: element.sex,
              pwd: element.pwd,
            };
            let res = await CompanyAddUser(params);
            if (res.Code < 1) {
              _this.$message.error(element.account + res.Message);
            } else {
              this.AddClanfrom.splice(index, 1);
              this.$message.success(element.account + res.Message);
            }
            this.dialogVisibleAddEmployees = false;
            this.GetCompanyUserList();
          }
        });
      });
    },
    copy() {
      var that = this;
      var clipboard = new ClipboardJS("#btn_Share", {
        text: function () {
          return that.EmpNum;
        },
      });
      clipboard.on("success", function (e) {
        that.$message.success("复制成功");
      });
      clipboard.on("error", function (e) {
        that.$message.error("复制失败！请手动复制。");
      });
    },
    // 邀请
    async Invitesubmit(row) {
      let res = await InvitUser({
        companyid: localStorage.uid,
        account: row == undefined ? this.InviteEmployeesOphoneNum : row.user01,
      });
      if (res.Code) {
        this.$message({
          type: "success",
          message: "邀请成功!",
        });
      } else {
        this.$message.error(res.Message);
      }
      this.dialogVisibleInviteEmployees = false;
      this.GetCompanyUserList();
    },
    // 移除
    del(row) {
      this.$confirm("确定移除员工【" + row.user02 + "】, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        DelCompanyUser({ companyid: localStorage.uid, uid: row.user01 }).then(
          (res) => {
            if (res.Code) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.GetCompanyUserList();
            }
          }
        );
      });
    },
    edit(row) {
      this.EditClanfrom = JSON.parse(JSON.stringify(row));
      this.EditClanfromphone = JSON.parse(JSON.stringify(row)).user05;
      this.dialogVisibleEditInfo = true;
      this.getdeps();
    },
    getdeps() {
      let params = { companyId: this.EditClanfrom.user08 };
      GetDeptZTree({ params }).then((res) => {
        this.deps = res.Data;
      });
    },
    async updateSave(fromref) {
      this.$refs[fromref].validate(async (v) => {
        if (v) {
          let params = this.EditClanfrom;
          this.EditClanfrom.user05 =
            this.EditClanfrom.user05 == this.EditClanfromphone
              ? null
              : this.EditClanfrom.user05;
          let res = await UpdateUser(params);
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          } else {
            this.$message({
              type: "error",
              message: res.Message,
            });
          }
          this.dialogVisibleEditInfo = false;
          this.GetCompanyUserList();
        }
      });
    },
    HandleUserInComoany(row, type) {
      HandleUserInComoany({
        uid: row.user01,
        companyId: parseInt(localStorage.uid),
        state: type,
      }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        } else {
          this.$message({
            type: "error",
            message: res.Message,
          });
        }
        this.GetCompanyUserList();
      });
    },
    // 部门树
    getTreeList() {
      let params = { companyId: localStorage.uid };
      GetDeptZTree({ params }).then((res) => {
        this.zNodes = res.Data;
      });
    },
    // 树形控件拖拽
    async upDrop({ moveNode, targetNode, moveType } = { ...data }) {
      let res = await ChangeDepttreeOrder({
        params: {
          oid: moveNode.dept01,
          nid: targetNode ? targetNode.dept01 : 0,
          moveType,
        },
      });
      this.getTreeList();
    },
    //树形控件添加方法
    async addTree(treeItem) {
      let _this = this;
      this.$prompt("请输入名称", "添加部门广场树")
        .then(({ value }) => {
          if (value) {
            AddDepttree({
              dept02: value,
              dept03: new Date(),
              dept04: localStorage.uid,
              dept05: treeItem ? treeItem.dept01 : 0,
              dept06: 0,
            }).then((res) => {
              this.$message.success("添加成功");
              _this.getTreeList();
            });
          } else {
            this.$message.info("空的名字");
            return false;
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    //树形控件删除方法
    async delTree(treeItem) {
      let res = await DelDepttree({ id: treeItem });
      if (res.Code) {
        this.$message.success("删除成功");
      }
      this.getTreeList();
    },
    //树形控件编辑方法
    async editTree({ newName, treeNode } = { ...item }) {
      let params = {
        id: treeNode.dept01,
        name: newName,
      };
      let res = await EditDepttree(params);
      this.$message.success("编辑成功");
      this.getTreeList();
    },
    clickTreeIds(ids) {
      this.ids = ids;
      this.GetCompanyUserList();
    },
    //重置
    rotate() {
      this.addRotate = true;
      setTimeout(() => {
        this.addRotate = false;
      }, 1000);
      this.search = "";
      this.GetCompanyUserList();
    },
    // 列表
    async GetCompanyUserList() {
      this.tableLoading = true;
      let params = {
        companyId: localStorage.uid,
        treeid: this.ids == "All" ? "All" : this.ids.toString(),
        seachword: this.search,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
      };
      let res = await GetCompanyUserList({ params });
      this.tableData = res.Data.list;
      this.tableLoading = false;
      this.total = res.Data.total;
    },
    async GetInvitationCode() {
      let res = await GetInvitationCode({ companyId: localStorage.uid });
      this.EmpNum = res.Data;
    },
    // 导出表格所用
    exportExcel() {
      var _this = this;
      const promise = new Promise(function (resolve, reject) {
        resolve();
      });
      promise.then(() => {
        let time = new Date();
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        let day = time.getDate();
        let Hours = time.getHours(); //获取系统时，
        let Minutes = time.getMinutes(); //分
        let Seconds = time.getSeconds(); //秒
        let name =
          "企业人员列表_" +
          year +
          "" +
          month +
          "" +
          day +
          "" +
          Hours +
          "" +
          Minutes +
          "" +
          Seconds;
        //  .table要导出的是哪一个表格
        var wb = XLSX.utils.table_to_book(document.querySelector(".table"));
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            name + ".xlsx"
          );
        } catch (e) {}
        return wbout;
      });
    },
    // 导出模板
    async ExportPersonTemplate() {
      let res = await ExportPersonTemplate({
        companyid: this.$store.state.pid,
      });
      if (res.Code == 0) {
        this.$message.error(res.Message);
      } else {
        var a = document.createElement("a");
        a.setAttribute("href", this.$store.state.baseUrl + res.Data);
        a.setAttribute("target", "_blank");
        a.setAttribute("id", "js_a");
        a.setAttribute("download", "download");
        //防止反复添加
        if (document.getElementById("js_a")) {
          document.body.removeChild(document.getElementById("js_a"));
        }
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(document.getElementById("js_a"));
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    beforeUpload(file) {
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "xlsx";
      //(suffix);
      if (!extension) {
        this.$message({
          message: "上传文件只能是 xlsx格式!",
          type: "warning",
        });
        //this.Uploadloading = true;
      }
      return extension;
    },
    // 上传成功
    uploadSuccess(data) {
      this.dialogVisibleExEmployees = false;
      if (data.Code > 0) {
        this.$message({
          type: "success",
          message: data.Message,
        });
        this.GetCompanyUserList();
        this.fileList = [];
      } else {
        this.$message({
          type: "warning",
          message: data.Message,
        });
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    submitUpload() {
      if (this.fileList.length > 0) {
        var _this = this;
        var fileReader = new FileReader();
        fileReader.onload = function (ev) {
          try {
            var data = ev.target.result;
            var workbook = XLSX.read(data, {
              type: "binary",
            }); // 以二进制流方式读取得到整份excel表格对象
            var persons = []; // 存储获取到的数据
          } catch (e) {
            _this.$message.error("文件类型不正确");
            return;
          }
          // 表格的表格范围，可用于判断表头是否数量是否正确
          var fromTo = "";
          // 遍历每张表读取
          for (var sheet in workbook.Sheets) {
            if (workbook.Sheets.hasOwnProperty(sheet)) {
              fromTo = workbook.Sheets[sheet]["!ref"];
              // console.log(fromTo);
              persons = persons.concat(
                XLSX.utils.sheet_to_json(workbook.Sheets[sheet])
              );
              // break; // 如果只取第一张表，就取消注释这行
            }
          }
          //在控制台打印出来表格中的数据
          persons.shift();
          persons
            .map((el) => Object.values(el))
            .forEach((k) => {
              let params = {
                companyid: localStorage.uid,
                account: k[0],
                name: k[1],
                pwd: k[2],
                sex: k[3],
              };
              CompanyAddUser(params).then((res) => {
                if (res.Code < 1) {
                  _this.$message.error(k[0] + res.Message);
                } else {
                  _this.$message.success("账号：" + k[0] + res.Message);
                }
              });
            });
        };
        fileReader.onloadend = function (e) {
          _this.dialogVisibleExEmployees = false;
          _this.ids = "All";
          _this.GetCompanyUserList();
          _this.$refs.upload.clearFiles();
        };
        fileReader.readAsBinaryString(this.fileList[0].raw);
      } else {
        this.$message({
          type: "warning",
          message: "请选择文件后上传",
        });
      }
    },
  },
  created() {
    this.getTreeList();
    this.GetCompanyUserList();
    this.GetInvitationCode();
  },
  mounted() {},
};
</script>
<style lang='less' scoped>
.adminiStration_zk {
  /deep/.el-card__body {
    height: 100%;
  }
  /deep/.el-tabs__content {
    height: 95%;
  }
  /deep/.el-tab-pane {
    height: 100%;
  }
  height: 100%;
  .el-card {
    height: 100%;
  }
  .el-card__header {
    span {
      letter-spacing: 1px;
      font-size: 18px;
      font-weight: 700;
    }
  }
  /deep/ .el-tabs__nav-wrap::after {
    width: 0px;
  }
  .topbtn button {
    margin-top: 10px;
    margin-left: 50px;
  }
  .inputzuhekuang /deep/ .el-input-group__append {
    background-color: #035dff;
  }
  .inputzuhekuang /deep/ .el-icon-search:before {
    color: white;
  }
  .go {
    transform: rotate(-720deg);
    transition: all 1s;
  }
  /deep/.el-tabs__item {
    font-size: 18px !important;
    font-weight: 700;
    color: #000;
  }
  /deep/.el-tabs__nav-wrap::after {
    width: 0px;
  }
  /deep/.el-tabs__active-bar {
    background-color: #035dff;
    height: 4px;
    border-radius: 35px;
  }
  /deep/.el-tabs__item.is-active {
    color: #000;
  }
}
/deep/ .el-dialog .el-dialog__header {
  text-align: center;
}
.jifen /deep/.el-input__inner {
  padding-right: 0px;
}
</style>